// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import featureCategories from "pages/Home/sections/data/featuresData";

function PropertyFeatures() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" textAlign="center" mb={1}>
          What&apos;s Included
        </MKTypography>
        <MKTypography variant="body1" color="text" textAlign="center" mb={4}>
          Everything you need for the perfect vacation
        </MKTypography>
        <Divider sx={{ mb: 4, width: "100%" }} />
        <Grid container spacing={4} justifyContent="center">
          {featureCategories.map((category) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={category.title}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <MKBox mb={3} sx={{ minWidth: 220 }}>
                <MKBox display="flex" alignItems="center" mb={1.5}>
                  <Icon sx={{ color: "info.main", fontSize: "1.5rem", mr: 1 }}>
                    {category.icon}
                  </Icon>
                  <MKTypography variant="h6">{category.title}</MKTypography>
                </MKBox>
                {category.items.map((item) => (
                  <MKBox key={item.label} display="flex" alignItems="center" mb={0.8} pl={0.5}>
                    <Icon sx={{ color: "success.main", fontSize: "1rem", mr: 1, flexShrink: 0 }}>
                      {item.icon}
                    </Icon>
                    <MKTypography variant="body2" color="dark">
                      {item.label}
                    </MKTypography>
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PropertyFeatures;
